import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import { InputFeedback, Input, InputGroup } from '@components/common';

function formatPhoneText(str) {
  if (!str) {
    return '';
  }
  const splits = str.match(/\d{1,3}/g);
  const [first, second, ...rest] = splits;

  let result = first;
  if (second) {
    result += '-' + second;
  }

  if (rest && rest.length > 0) {
    result += '-' + rest.join('');
  }

  return result;
}

// Todo: error status
function PhoneField(props) {
  const { field, label, form, renderAddon, ...rest } = props;
  const formError = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = !!(touched && formError);

  const handleOnChange = e => {
    const newValue = e.target.value.replace(/\D/, '');
    const formatted = formatPhoneText(newValue);

    form.setFieldValue(field.name, formatted);
  };

  return (
    <InputGroup>
      <Input
        placeholder={label}
        error={hasError}
        disabled={form.isSubmitting}
        onChange={handleOnChange}
        value={field.value}
        onBlur={() => {
          form.setFieldTouched(field.name);
        }}
        {...rest}
      />
      {renderAddon && renderAddon()}
      {hasError && <InputFeedback>{formError}</InputFeedback>}
    </InputGroup>
  );
}

PhoneField.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.string,
  renderAddon: PropTypes.func
};

export default PhoneField;
